import { createSlice, PayloadAction } from "@reduxjs/toolkit";

//import { TExoThemeContext } from "@/messenger/types/exoContext.types";

const exoContext = createSlice({
    name: "exoContext",
    initialState: {
        theme: null,
        appContext: null,
    },
    reducers: {
        upsertExoTheme(state, action: PayloadAction<any>) {
            state.theme = action.payload;
        },
        upsertExoAppContext(state, action: PayloadAction<any>) {
            state.appContext = action.payload;
        },
    },
});

export const {
    upsertExoTheme,
    upsertExoAppContext,
} = exoContext.actions;


export default exoContext.reducer;
